import React from "react"
import { Box, Flex } from "@rebass/grid/emotion"
import styled from "@emotion/styled"

import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

const SectionHeading = styled(TextElement)`
  text-align: center;
  ${queries.medium`
    text-align: left;
  `}
`

const ContentFlex = styled(Flex)`
  @media (min-width: 768px) {
    max-width: 671px;
    margin: auto;
  }
  @media (min-width: 1024px) {
    max-width: 1100px;
  }
  @media (min-width: 1280px) {
    max-width: 100%;
  }
`

const ClinicalProof = ({ data }) => {
  const ImageBox = styled(Box)`
    background: url(${data.image}) 50% 50% / cover;
    padding-bottom: 85%;
    border-radius: 8px;
    ${queries.medium`
      background: url(${data.imagealt || data.image}) 50% 15% / cover;
      padding-bottom: 57%;
    `}
    ${queries.large`
        background: url(${data.image}) 50% 50% / cover;
      padding-bottom: 37.5%;
    `}
  `
  const StatBox = styled(Box)`
    border-bottom: 1px solid ${theme.wild.color.master.base.alt.secondary};

    &.box-0 {
      border-top: 1px solid ${theme.wild.color.master.base.alt.secondary};
    }

    .stat-number {
      @media (min-width: 1024px) and (max-width: 1279px) {
        font-size: 32px !important;
        line-height: 38px !important;
      }
    }
  `

  const listStats = data.stats.map((stat, i) => (
    <StatBox
      width={1}
      className={`box-${i} ${stat.isVegan ? "vegan" : ""}`}
      py={24}
      key={`${stat.number}-${i}`}
    >
      <Flex flexWrap="wrap" alignItems="center">
        <Box width={[80, 80, 96, 96, 136]}>
          <TextElement
            text={stat.number}
            element="p"
            className="title--large text-master-primary-default stat-number"
          />
        </Box>
        <Box flex="1" alignSelf="center" px={[0, 0, 0, 16]}>
          <TextElement
            text={stat.text}
            element="p"
            className="body--regular hide-xlg-up text-master-base-black"
          />
          <TextElement
            text={stat.text}
            element="p"
            className="body--large show-xlg-up text-master-base-black"
          />
        </Box>
      </Flex>
    </StatBox>
  ))

  return (
    <Flex pt={data.pt} pb={data.pb}>
      <Box width={1} className="wild-container" py={[0, 0, 0]}>
        <ContentFlex flexWrap="wrap" mx={0} alignItems="center">
          <Box
            width={[1, 1, 0.5, "49.5%"]}
            pl={[0, 0, 4, 4, 6]}
            pr={[0, 0, 4, 4, 6]}
            order={[1, 1, 0]}
          >
            <SectionHeading
              text={data.heading}
              element="h2"
              className="title--medium text-master-base-black"
            />
            <Flex
              flexWrap="wrap"
              mb={[0]}
              mt={[16, 16, 24, 40]}
              maxWidth={[null, null, 488]}
              height={"100%"}
            >
              {listStats}
            </Flex>
          </Box>
          <ImageBox
            width={[1, 1, 0.5, "50.5%"]}
            px={[0, 0, 2]}
            mb={[24, 24, 0]}
            order={[0, 0, 1]}
          ></ImageBox>
        </ContentFlex>
      </Box>
    </Flex>
  )
}
export default ClinicalProof
